import React from 'react';
import './TeraGuide.css';

const TeraGuide = () => {
  return (
    <div className="tera-guide">
      <div className="tera-guide__header">
        <h1>Understanding Terastallization</h1>
        <p className="tera-guide__intro">
          Terastallization is a powerful mechanic introduced in Generation 9 that allows Pokémon to change their type during battle.
        </p>
      </div>

      <div className="tera-guide__content">
        <section className="tera-guide__section">
          <h2>What is Terastallization?</h2>
          <p>
            Terastallization (or "Tera" for short) is a battle mechanic that transforms your Pokémon into a crystalline form
            and changes its type to its Tera type. Every Pokémon in Paldea has a Tera type, which can be different from its
            original typing.
          </p>
        </section>

        <section className="tera-guide__section">
          <h2>Key Features</h2>
          <ul className="tera-guide__features">
            <li>
              <h3>One-Time Use</h3>
              <p>You can only Terastallize one Pokémon once per battle.</p>
            </li>
            <li>
              <h3>Type Change</h3>
              <p>When a Pokémon Terastallizes, it changes to its Tera type and loses its original typing.</p>
            </li>
            <li>
              <h3>STAB Bonus</h3>
              <p>
                If a Terastallized Pokémon uses a move matching its Tera type:
                <ul>
                  <li>Gets 2x STAB if the Tera type matches one of its original types</li>
                  <li>Gets 1.5x STAB if the Tera type is different from its original types</li>
                </ul>
              </p>
            </li>
          </ul>
        </section>

        <section className="tera-guide__section">
          <h2>Strategic Uses</h2>
          <div className="tera-guide__strategies">
            <div className="strategy-card">
              <h3>Offensive</h3>
              <ul>
                <li>Boost STAB damage with matching Tera type</li>
                <li>Surprise opponents with unexpected type coverage</li>
                <li>Change weaknesses to counter threats</li>
              </ul>
            </div>
            <div className="strategy-card">
              <h3>Defensive</h3>
              <ul>
                <li>Neutralize type weaknesses</li>
                <li>Gain resistances to opponent's moves</li>
                <li>Create favorable defensive matchups</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="tera-guide__section">
          <h2>Common Competitive Strategies</h2>
          <div className="tera-guide__examples">
            <div className="example-card">
              <h3>Same-Type Terastallization</h3>
              <p>
                Terastallizing into one of your original types for a 2x STAB boost.
                Example: Fire-type Charizard with Fire Tera type for powerful Fire moves.
              </p>
            </div>
            <div className="example-card">
              <h3>Coverage Terastallization</h3>
              <p>
                Terastallizing into a different type to gain new offensive coverage.
                Example: Dragon-type Garchomp with Steel Tera type to hit Fairy-types.
              </p>
            </div>
            <div className="example-card">
              <h3>Defensive Terastallization</h3>
              <p>
                Terastallizing to remove weaknesses or gain resistances.
                Example: Ice/Ghost-type Froslass with Water Tera type to remove Rock weakness.
              </p>
            </div>
          </div>
        </section>

        <section className="tera-guide__section">
          <h2>Tips for Using Terastallization</h2>
          <ul className="tera-guide__tips">
            <li>Consider your team's weaknesses when choosing Tera types</li>
            <li>Don't Terastallize too early - timing is crucial</li>
            <li>Use unexpected Tera types to surprise opponents</li>
            <li>Plan your moveset around your intended Tera type</li>
            <li>Remember you can only Terastallize once per battle</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default TeraGuide; 